const en = {
  テスト: 'test',
  黒田: 'kuroda',
}
export default en
